var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"crly-a-contents-complete-btn",on:{"click":_vm.clickCompleteBtn}},[_vm._v(" "+_vm._s(_vm.$t("headerNav.btn.complete"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }